/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { css, cx } from '@emotion/css';
import merge from 'deepmerge';
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import overflowStyle from '../../styles/OverflowItem/OverflowItemCss';

const dynamicWidth = {
  width: 'auto',
};

const popupDirection = {};

/**
 * If labelComponent onClick not recognized then
 * labelComponentClicked can be used to trigger the action
 */
const OverflowItem = ({
  labelComponent,
  children,
  theme,
  onPopupToggle,
  width,
  isLabelComponentClicked,
  id,
  isOutsideClick = true,
  isDisable = false,
  setLabelComponentClicked,
  toggleDirection,
}) => {
  const [toggle, setToggle] = useState(false);

  const wrapperRef = useRef(null);
  const labelRef = useRef(null);

  const styleObj = merge.all([overflowStyle, theme || {}]);

  const changeToggle = (e, newToggleVal) => {
    dynamicWidth.width = `${width || labelRef.current.clientWidth}px !important`;
    if (toggleDirection) popupDirection[toggleDirection] = `-${dynamicWidth.width}`;
    setToggle(newToggleVal);
    if (onPopupToggle) {
      onPopupToggle(e, newToggleVal);
    }
  };

  useEffect(() => {
    setToggle(false);
  }, []);

  useEffect(() => {
    /**
     * if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (
        labelRef.current
        && !labelRef.current.contains(event.target)
        && wrapperRef.current
        && !wrapperRef.current.contains(event.target)
      ) {
        changeToggle(event, false);
        setLabelComponentClicked(false);
      }
    }

    // Bind the event listener only if Overflow Item is open
    if (toggle === true && isOutsideClick) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [toggle]);

  const onLabelComponentClick = (e) => {
    changeToggle(e, !toggle);
  };

  useEffect(() => {
    changeToggle(labelRef.current.target, isLabelComponentClicked);
  }, [isLabelComponentClicked]);

  return (
    <div id={`${id || 'overflow-item'}-container`} style={{ position: 'relative' }}>
      <div
        id={`${id || 'overflow-item-container'}-label`}
        onClick={isDisable ? null : onLabelComponentClick}
        onKeyPress={isDisable ? null : onLabelComponentClick}
        ref={labelRef}
      >
        {labelComponent}
      </div>
      <div
        id={`${id || 'overflow-item-container'}-children`}
        key="overflow-item"
        ref={wrapperRef}
        className={cx(
          { [css(dynamicWidth)]: toggle },
          { [css(styleObj['.overFlowPopUpVisible'])]: toggle },
          { [css(styleObj['.overFlowPopUpHidden'])]: !toggle },
          { [css(popupDirection)]: toggle && toggleDirection }
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default OverflowItem;

OverflowItem.propTypes = {
  labelComponent: PropTypes.node.isRequired,
  isLabelComponentClicked: PropTypes.bool,
  children: PropTypes.node,
  theme: PropTypes.shape({}),
  onPopupToggle: PropTypes.func,
  width: PropTypes.string,
  id: PropTypes.string.isRequired,
  isOutsideClick: PropTypes.bool,
  isDisable: PropTypes.bool,
  setLabelComponentClicked: PropTypes.func,
  toggleDirection: PropTypes.string,
};

OverflowItem.defaultProps = {
  setLabelComponentClicked: () => {},
};
